export const TWILIO_BASE_URL = "https://verify.twilio.com/v2/Services/";

export const TWILIO_ACCOUNT_SID =
  process.env.REACT_APP_TWILIO_ACCOUNT_SID ?? "";
export const TWILIO_AUTH_TOKEN = process.env.REACT_APP_TWILIO_AUTH_TOKEN ?? "";
export const TWILIO_SERVICE_SID =
  process.env.REACT_APP_TWILIO_SERVICE_SID ?? "";
